import React, { FunctionComponent } from 'react';
import { Typography, Breadcrumbs } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import usePageBreadcrumbs from './PageBreadcrumbs.styles';

export type BreadcrumbItem = { label: string; path?: string | null };

interface PageBreadcrumbsProps {
  items: BreadcrumbItem[];
  separator?: string;
  enableNewLayout?: boolean;
}

const PageBreadcrumbs: FunctionComponent<React.PropsWithChildren<PageBreadcrumbsProps>> = ({
  items,
  separator = '/',
  enableNewLayout = false,
}) => {
  const { translate } = useTranslation();
  const {
    cx,
    classes: { link, iaLink },
  } = usePageBreadcrumbs();

  return (
    <Breadcrumbs aria-label={translate('Label.Breadcrumbs')} separator={separator}>
      {items.map((item, index) => {
        const isLast = items.length - 1 === index;
        const labelColor = isLast ? 'primary' : 'secondary';
        const { label } = item;
        if (item.path) {
          return (
            <DynamicallyRouted.Link
              key={label}
              href={item.path}
              className={cx(link, { [iaLink]: enableNewLayout })}>
              <Typography color={enableNewLayout ? labelColor : undefined}>{label}</Typography>
            </DynamicallyRouted.Link>
          );
        }
        return (
          <Typography key={label} color={labelColor}>
            {label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export default PageBreadcrumbs;
